import { actions, selectors } from '../../../state';
import { ITEM_DEFINITION_CODES } from '../../../constants/item-definitions';
import { IS_DEMO } from '@updater-core/lib/environment';
import '@updater-components/strikethrough';
import '@updater-components/dialog';
import template from './message-center.html';
import './message-center.global.css';

const { track } = actions.analytics;
const { HOME_SERVICE, HOME_SERVICE_APP } = ITEM_DEFINITION_CODES;
const FAKE_PHONE_NUMBER = '18885555555';
const BRIDGEVINE_PHONE_NUMBER = '18332248974';

class MessageCenterController {
  constructor(updStore, $element) {
    'ngInject';

    Object.assign(this, { updStore, $element });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    this.trackClose = this.trackClose.bind(this);
  }

  $onDestroy() {
    this.disconnect();
    this.dialog.removeEventListener('close', this.trackClose);
  }

  $postLink() {
    this.dialog = this.$element[0].querySelector('upd-dialog');
    this.dialog.addEventListener('close', this.trackClose);
  }

  closeDialog() {
    this.dialog.close();
  }

  openDialog() {
    this.dialog.showModal();
    this.updStore.dispatch(track('Viewed Concierge Modal'));
  }

  trackClose() {
    this.updStore.dispatch(track('Clicked close on Concierge Modal'));
  }
}

function mapStateToThis(state) {
  const { byCode } = selectors.itemDefinition;
  const hasTvInternet = !!(
    byCode(HOME_SERVICE_APP).code(state) || byCode(HOME_SERVICE).code(state)
  );

  return {
    homeServicesPhoneNumber: IS_DEMO
      ? FAKE_PHONE_NUMBER
      : hasTvInternet
      ? BRIDGEVINE_PHONE_NUMBER
      : null,
  };
}

export const MessageCenterComponent = {
  controller: MessageCenterController,
  template,
};
